import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Tooltip, OverlayTrigger } from 'react-bootstrap';

//components
import applicationRouter from '~/hoc/applicationRouter';
import withLocalization from '~/hoc/withLocalization';
import Radio from '../../../../components/CustomRadio/CustomRadio.jsx';
import SwitchWidget from '../SwitchWidget.js';
import TableWidget from '../TableWidget.js';
import WagetypeRefetch from '../WagetypeRefetch.js';

//elements
import Select from '../../../../elements/Select.js';
import { NumberInput } from '../../../../elements/Input.js';

//utils
import { translateLabels, resolveWageTypeCodeLabel } from '../../../../utils/commonMethods.js';
import { WAGE_TYPE_HOURLY_FALLBACK_NOTE, DEFAULT_OVERTIME_WAGE_TYPE } from '../../../../utils/constants.js';

const calc_periodOption = [{ value: 'none', label: 'None', key: 'None' },
{ value: 'day', label: 'Day', key: 'Day' }, { value: 'week', label: 'Week', key: 'Week' },
{
    value: 'government',
    label: 'Hours in excess of nine hours in the course of 24 hours and 40 hours in the course of seven days',
    key: 'Hours in excess of nine hours in the course of 24 hours and 40 hours in the course of seven days'
}]

class OverTimeCalculation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            overtimeAutomaticMode: false,
            overtimeCalcRules: {
                calc_percent: 0,
                calc_period: 'none',
                max_hours: 0,
                max_minutes: 0,
                weekend_percent: 0,
                integrated_wageType: null,
            },
            overtime_types: [],
            overtimeThresoldMinutes: 15,
            wageType: props.commonStore.getWageTypesAccordingToIntegrations(props.commonStore?.config?.integration_details, 'at') || [],
            lastUpdated: props.commonStore.getWageTypesAccordingToIntegrations(props.commonStore?.config?.integration_details, 'last_updated') || null,
            isLoadingWageTypes: false,
            showAllWageTypes: false,
            requireCommentForOvertime: false,
            requireCommentForMandatoryOrUrgentWorkOvertime: false
        }
        this.handleChange = this.handleChange.bind(this);
        this.loadData = this.loadData.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    handleSwitch = (name, evt) => {
        this.props.handleUserDataChange(name, evt);
        if (name === 'requireCommentForOvertime' && !evt) {
            this.props.handleUserDataChange('requireCommentForMandatoryOrUrgentWorkOvertime', false);
            return this.setState({ requireCommentForOvertime: false, requireCommentForMandatoryOrUrgentWorkOvertime: false });
        }
        this.setState({ [name]: evt });
    }

    loadData = () => {
        const { currentEntity } = this.props.clientStore;
        if (currentEntity.client.data && currentEntity.client.data.basicRules) {
            const basicRules = Object.assign({}, currentEntity.client.data.basicRules);
            this.setState({
                requireCommentForOvertime: basicRules.requireCommentForOvertime ? basicRules.requireCommentForOvertime : false,
                requireCommentForMandatoryOrUrgentWorkOvertime: basicRules.requireCommentForMandatoryOrUrgentWorkOvertime ? basicRules.requireCommentForMandatoryOrUrgentWorkOvertime : false
            });
            if (basicRules.overtimeCalcRules) {
                this.setState({
                    overtimeAutomaticMode: basicRules.overtimeAutomaticMode,
                    overtimeCalcRules: basicRules.overtimeCalcRules,
                    overtime_types: basicRules.overtime_types,
                    overtimeThresoldMinutes: basicRules.overtimeThresoldMinutes
                })
            }
            else {
                this.setState({
                    overtime_types: basicRules.overtime_types,
                    overtimeThresoldMinutes: basicRules.overtimeThresoldMinutes
                })
            }
        }
    }


    validateInputs(name, value) {
        const { overtimeCalcRules } = this.state;
        const { t } = this.props
        let isError = false
        if (name === 'max_minutes' && value > 59)
            isError = t('Minutes can not be greater than 59 instead add hour');
        if (name === 'max_hours') {
            switch (overtimeCalcRules.calc_period) {
                case 'day':
                    if (value > 23) isError = t('Max hours can not be greater than 23')
                    break;
                case 'week':
                    if (value > 167) isError = t('Max hours can not be greater than 167')
                    break;
                case 'month':
                    if (value > 743) isError = t('Max hours can not be greater than 743')
                    break;
                default:
            }
        }
        return isError
    }

    handleChange = (name, value) => {
        const isError = this.validateInputs(name, value)
        if (isError) return this.props.commonStore.addNotification(isError, null, 'error');
        const { overtimeCalcRules, overtimeThresoldMinutes } = this.state;
        overtimeCalcRules[name] = value;
        this.props.handleUserDataChange('overtimeCalcRules', overtimeCalcRules);
        this.setState({ overtimeCalcRules, overtimeThresoldMinutes });
    }

    refetchWageType = async () => {
        const { commonStore, t } = this.props;
        try {
            await commonStore.refetchWagetypes();
            commonStore.addNotification(t('Successfully refetched wagetypes'), null, 'success');
            const _wagetype = commonStore.getWageTypesAccordingToIntegrations(commonStore?.config?.integration_details, 'at') || [];
            const _lastUpdated = commonStore.getWageTypesAccordingToIntegrations(commonStore?.config?.integration_details, 'last_updated') || null;
            this.setState({ wageType: _wagetype, lastUpdated: _lastUpdated, isLoadingWageTypes: false });

        } catch (err) {
            console.error(err);
            commonStore.addNotification(t('Something went wrong'), null, 'error');
            this.setState({ isLoadingWageTypes: false });
        }
    }

    handleInputRange = (e) => {
        e.persist();
        let _overtimeThresoldMinutes = e.target.value;
        this.props.handleUserDataChange('overtimeThresoldMinutes', _overtimeThresoldMinutes);
        this.setState({ overtimeThresoldMinutes: _overtimeThresoldMinutes });
    }

    renderManualOvertimes = () => {
        const { overtime_types, wageType, showAllWageTypes } = this.state;
        const effectiveWageType = showAllWageTypes ? this.props.commonStore.getAllWageTypesCombined() : wageType;
        let headers = ['Unique id', 'Amount', 'Label'],
            metaData = [{ field: 'code', type: 'text', placeholder: '0', required: true, unique: true },
            { field: 'multiplier', type: 'number', placeholder: 0, required: true, unique: true },
            { field: 'name', type: 'text', placeholder: '%', required: true, unique: true }];

        if (wageType?.length) {
            headers = ['Unique id', 'Wage Type (Fixed Salary)', 'Wage Type (Hourly)', 'Amount', 'Label'];
            metaData = [{ field: 'code', type: 'text', placeholder: '0', required: true, unique: true, wrapperClass: 'w-100', thStyle: { width: '100px' }, tdStyle: { width: '100px' } },
            { field: 'payrollWageType', type: 'select', placeholder: 'Wage Type', select: true, data: effectiveWageType, unique: true, thStyle: { width: '200px' }, tdStyle: { width: '200px', minWidth: '200px' } },
            { field: 'payrollWageTypeHourly', type: 'select', placeholder: 'Wage Type', select: true, data: effectiveWageType, thStyle: { width: '200px' }, tdStyle: { width: '200px', minWidth: '200px' } },
            { field: 'multiplier', type: 'number', placeholder: 0, required: true, unique: true, wrapperClass: 'w-100', thStyle: { width: '100px' }, tdStyle: { width: '100px' } },
            { field: 'name', type: 'text', placeholder: '%', required: true, unique: true, wrapperClass: 'w-100', thStyle: { width: '120px' }, tdStyle: { width: '120px' } }];
        }

        const tableData = overtime_types?.map(item => ({ ...item, payrollWageTypeHourly: item?.hourlyPayrollWageType }));

        return (
            <div className='mt-2'>
                <TableWidget
                    headers={headers}
                    metaData={metaData}
                    data={tableData}
                    onChange={data => {
                        const mapped = data.map(({ payrollWageTypeHourly, ...item }) => ({
                            ...item,
                            hourlyPayrollWageType: payrollWageTypeHourly || null
                        }));
                        this.props.handleUserDataChange('overtime_types', mapped);
                    }}
                    className='mb-100'
                />
            </div>
        )
    }

    renderAutomaticOvertimes = () => {
        const { overtimeCalcRules, wageType, overtimeThresoldMinutes, showAllWageTypes } = this.state;
        const effectiveWageType = showAllWageTypes ? this.props.commonStore.getAllWageTypesCombined() : wageType;
        const { t } = this.props;
        return (
            <div className='mt-2'>
                <Row>
                    <Col sm={4} className="mb-3">
                        <label className="control-label">{t('Period')}</label>
                        <Select
                            options={calc_periodOption}
                            value={calc_periodOption.find(item => item.value === overtimeCalcRules.calc_period)}
                            onChange={period => {
                                this.handleChange('calc_period', period.value)
                                if (period.value === "government") {
                                    this.handleChange('max_hours', 9);
                                    this.handleChange('max_minutes', 0);
                                }
                                if (period.value === "none") {
                                    this.handleChange('max_hours', 0);
                                    this.handleChange('max_minutes', 0);
                                    this.handleChange('calc_percent', 0);
                                    this.handleChange('weekend_percent', 0);
                                }
                            }}
                            style={{ width: '100%' }}
                        />
                    </Col>
                    <Col sm={4} xs={6} className="mb-3">
                        <NumberInput
                            label={`${t('Maximum hours')} (hh)`}
                            name="max_hours"
                            value={overtimeCalcRules.max_hours}
                            onChange={evt => {
                                this.handleChange('max_hours', parseInt(evt.target.value, 10));
                            }}
                            disabled={overtimeCalcRules.calc_period === "government" || overtimeCalcRules.calc_period === 'none'}
                        />
                    </Col>
                    <Col sm={4} xs={6} className="mb-3">
                        <NumberInput
                            label={`${t('Maximum Minutes')} (mm)`}
                            name="max_minutes"
                            value={overtimeCalcRules.max_minutes}
                            onChange={evt => {
                                this.handleChange('max_minutes', parseInt(evt.target.value, 10));
                            }}
                            disabled={overtimeCalcRules.calc_period === "government" || overtimeCalcRules.calc_period === 'none'}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm={4} xs={6}>
                        <NumberInput
                            label={`${t('Overtime')} (%)`}
                            name="Overtime"
                            value={overtimeCalcRules.calc_percent}
                            onChange={evt => {
                                this.handleChange('calc_percent', parseInt(evt.target.value, 10));
                            }}
                            disabled={overtimeCalcRules.calc_period === 'none'}
                        />
                    </Col>
                    <Col sm={4} xs={6}>
                        <NumberInput
                            label={`${t('Additional pay for weekend')}`}
                            name="weekend_percent"
                            value={overtimeCalcRules.weekend_percent}
                            onChange={evt => {
                                this.handleChange('weekend_percent', parseInt(evt.target.value, 10));
                            }}
                            disabled={overtimeCalcRules.calc_period === 'none'}
                        />
                    </Col>
                    <Col sm={4} xs={6}>
                        <label className="control-label">{t('Overtime threshold')}</label>
                        <div className="slider-parent">
                            <input type="range" min="1" max="60"
                                onChange={event => this.handleInputRange(event)}
                                value={overtimeThresoldMinutes}
                            />
                            <div className="buble">
                                {overtimeThresoldMinutes} {t('Minutes')}
                            </div>
                        </div>
                    </Col>
                </Row>
                {!!wageType?.length && overtimeCalcRules.calc_period === 'day' &&
                    <Row>
                        <Col sm={4} xs={6}>
                            <label className="control-label">{t('Select Overtime Type')} ({t('Fixed Salary')})</label>
                            <Select
                                options={effectiveWageType}
                                onChange={(e) => this.handleChange('integrated_wageType', e)}
                                value={effectiveWageType?.find(ele => ele?.value === overtimeCalcRules?.integrated_wageType?.value)}
                                style={{ width: '100%' }}
                            />
                        </Col>
                        <Col sm={4} xs={6}>
                            <label className="control-label">{t('Select Overtime Type')} ({t('Hourly')})</label>
                            <Select
                                options={effectiveWageType}
                                isClearable
                                onChange={(e) => this.handleChange('hourlyIntegratedWageType', e || null)}
                                value={effectiveWageType?.find(ele => ele?.value === overtimeCalcRules?.hourlyIntegratedWageType?.value)}
                                style={{ width: '100%' }}
                            />
                        </Col>
                    </Row>
                }
                {(overtimeCalcRules.calc_period === 'government' || overtimeCalcRules.calc_period === 'week') &&
                    <Row className='mt-2'>
                        <p className='font-size-12'><span className='font-size-15 fw-bold'>{t('Note')}:&nbsp;</span>
                            {overtimeCalcRules.calc_period === 'government' ? t('Weekly overtime calculations for government rules will be based on a week starting from Monday and ending on Sunday')
                                : t("Weekly overtime calculations will be based on the start day of the week set in the 'Week Start Day' settings under 'Rules for Start & Break Time'")}.
                        </p>
                    </Row>
                }
            </div>
        )
    }

    render() {
        const { overtimeAutomaticMode, wageType, lastUpdated, isLoadingWageTypes, showAllWageTypes,
            requireCommentForOvertime, requireCommentForMandatoryOrUrgentWorkOvertime } = this.state;
        const clientBasicRules = this.props.clientStore.currentEntity?.client?.data?.basicRules || {};
        const canIncludeMandatoryOrUrgentWork = !!(clientBasicRules.allowManagingTimelogsManually
            || clientBasicRules.urgentWorkSettings?.allowUrgentWork);
        const { t, commonStore } = this.props;
        translateLabels(calc_periodOption, t, 'label');
        const defaultOvertimeWageTypeCode = DEFAULT_OVERTIME_WAGE_TYPE[commonStore?.config?.integration_details?.product];
        const defaultOvertimeWageType = resolveWageTypeCodeLabel(defaultOvertimeWageTypeCode, commonStore);
        const wageTypeNote = `${t(WAGE_TYPE_HOURLY_FALLBACK_NOTE)}${defaultOvertimeWageType ? ` ${t('If left blank, the system will use its built-in default wage type')}: "${defaultOvertimeWageType}".` : ''}`;
        return (
            <div>
                <div className="custom-form__row center-block">
                    <div className="custom-form__row" style={{ margin: 10 }}>
                        <Radio
                            label={t('Manual')}
                            checked={!overtimeAutomaticMode}
                            onChange={() => this.setState(prevState => ({ overtimeAutomaticMode: !prevState.overtimeAutomaticMode }),
                                () => {
                                    this.props.handleUserDataChange('overtimeAutomaticMode', this.state.overtimeAutomaticMode);
                                    if (!this.state.overtimeAutomaticMode && this.state.overtimeCalcRules.calc_period !== calc_periodOption[0].value) {
                                        this.handleChange('calc_period', calc_periodOption[0].value);
                                        this.handleChange('max_hours', 0);
                                        this.handleChange('max_minutes', 0);
                                        this.handleChange('calc_percent', 0);
                                        this.handleChange('weekend_percent', 0);
                                    }
                                })} />
                    </div>
                    <div className="custom-form__row" style={{ margin: 10 }}>
                        <Radio
                            label={t('Automatic')}
                            checked={overtimeAutomaticMode}
                            onChange={() => this.setState(prevState => ({ overtimeAutomaticMode: !prevState.overtimeAutomaticMode }),
                                () => this.props.handleUserDataChange('overtimeAutomaticMode', this.state.overtimeAutomaticMode))} />
                    </div>
                    <div className='d-flex mt-12 ml-30'>
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {overtimeAutomaticMode ?
                                        t(`This function allows your company to calculate overtime automatically for all users. You can select the period, such as daily or weekly, and enter the maximum number of hours after which overtime should be calculated, for example, 9 hours. This means that when a user has worked for 9 hours and is still at work, they will be paid according to the set overtime percentage, for example, 50%. This means that if a user works for 1 hour, they will be paid for 1 hour and 30 minutes`)
                                        :
                                        t(`If this option is turned on, the user must select a listed percentage of overtime and add it to their working hours. For example, if a user worked for 9 hours and wants to claim 1 hour as overtime, they would add 1 hour as 50% from the overtime list in the mobile app`)
                                    }.
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </div>
                </div>
                {!!wageType.length &&
                    <WagetypeRefetch
                        t={this.props.t}
                        refetch={() => this.setState({ isLoadingWageTypes: true }, this.refetchWageType)}
                        lastUpdated={lastUpdated}
                        isLoading={isLoadingWageTypes}
                        dateTimeRules={this.props.commonStore.getDateTimeRules()}
                        extraNote={wageTypeNote}
                        showAllWageTypes={showAllWageTypes}
                        onToggleShowAllWageTypes={(value) => this.setState({ showAllWageTypes: value })}
                    />
                }
                {/* Overtime comments are only asked for in manual mode here - the same condition the
                    server applies for clients without company shifts */}
                {!overtimeAutomaticMode &&
                    <Row className="mt-2">
                        <Col sm={6}>
                            <Row>
                                <Col sm={2} className="mt-1">
                                    <SwitchWidget
                                        value={requireCommentForOvertime}
                                        onChange={checked => this.handleSwitch('requireCommentForOvertime', checked)} />
                                </Col>
                                <Col sm={10}>
                                    <label className="control-label">{t('Require comment for overtime hours')}</label>
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("When enabled, a comment must be added to the timesheet if it contains overtime hours.")}
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </Col>
                            </Row>
                        </Col>
                        {canIncludeMandatoryOrUrgentWork &&
                            <Col sm={6}>
                                <Row>
                                    <Col sm={2} className="mt-1">
                                        <SwitchWidget
                                            value={requireCommentForMandatoryOrUrgentWorkOvertime}
                                            disabled={!requireCommentForOvertime}
                                            onChange={checked => this.handleSwitch('requireCommentForMandatoryOrUrgentWorkOvertime', checked)} />
                                    </Col>
                                    <Col sm={10}>
                                        <label className="control-label">{t('Include Mandatory / Urgent Work overtime')}</label>
                                        <OverlayTrigger
                                            placement="left"
                                            overlay={
                                                <Tooltip id="tooltip-top">
                                                    {t("When enabled, the comment is also required on timesheets registered as mandatory overtime or urgent work.")}
                                                </Tooltip>
                                            }
                                        >
                                            <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                        </OverlayTrigger>
                                    </Col>
                                </Row>
                            </Col>
                        }
                    </Row>
                }
                {overtimeAutomaticMode ? this.renderAutomaticOvertimes() : this.renderManualOvertimes()}
            </div >
        );
    }
}
export default inject('clientStore', 'commonStore', 'userStore')(applicationRouter(withLocalization(observer(OverTimeCalculation))));